import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04ca3ea2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  class: "login_box"
};
const _hoisted_3 = {
  class: "back"
};
const _hoisted_4 = {
  class: "cont-main"
};
const _hoisted_5 = {
  class: "tabs"
};
const _hoisted_6 = {
  class: "index-slide-nav"
};
const _hoisted_7 = {
  class: "form"
};
const _hoisted_8 = {
  style: {
    "font-size": "12px",
    "text-align": "center",
    "margin-top": "15px"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  name: "xieyi",
  style: {
    "vertical-align": "middle"
  }
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "button",
  value: "注册"
}, null, -1));
const _hoisted_11 = [_hoisted_10];
import api from "@/api";
import fun from "@/utils/fun";
import router from "@/router";
import moment from "moment";
import { reactive } from 'vue';
import { showToast, showFailToast, showSuccessToast } from "vant";
//import vueImgVerify from '../../components/vueImgVerify.vue'
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const data = reactive({
      email: null,
      username: null,
      pwd: null,
      pwds: null,
      realname: null,
      idcard: null,
      phone: null,
      smcode: null,
      codeName: '发送验证码',
      codeDisabled: false,
      nowTime: null
    });
    /* onMounted(()=>{
        const time=moment(new Date).format('YYYY')
        data.nowTime=data.nowTime-18
    }) */
    //获取验证码
    const getCode = async () => {
      if (data.phone.length !== 11) return showToast('请输入正确的手机号码');
      const res = await api.getCode(data.phone);
      console.log(res);
      if (res.data.msg !== 'success') return showFailToast(res.data.msg);
      data.codeDisabled = true;
      fun.clearTimer();
      fun.startTimer({
        time: 59,
        onThrob: second => {
          data.codeName = second + 'S';
        },
        onOver: () => {
          data.codeName = '发送验证码';
          data.codeDisabled = false;
        }
      });
      showToast('验证码已发送至您的手机！');
    };
    //校验验证码
    const checkCode = () => {
      api.checkCode(data.phone, data.smcode).then(async res => {
        if (res.data.code == '0' || data.code == '0011') {
          window.localStorage.setItem('mobile', data.phone);
          await fun.clearTimer();
          data.code = null;
          register();
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    const login = () => {
      if (!data.email || !data.email.includes('@')) return showToast('请输入正确的邮箱地址');
      if (!data.username) return showToast('请输入您的用户名');
      if (data.username.length < 4) return showToast('请按要求设置您的用户名');
      if (!data.pwd) return showToast('请设置登录密码');
      if (data.pwd.length < 6) return showToast('请按要求设置您的登录密码');
      if (data.pwds !== data.pwd) return showToast('两次密码不一致');
      if (!data.realname) return showToast('请输入正确的姓名');
      if (!data.idcard || data.idcard.length !== 18) return showToast('身份证号位数不正确');
      if (!data.phone || data.phone.length !== 11) return showToast('请输入正确的手机号');
      if (!data.smcode) return showToast('请输入正确的验证码');
      checkCode();
    };
    const register = async () => {
      await api.register(data.username, data.pwd, data.email, data.realname, data.idcard).then(res => {
        if (res.data.code == 0) {
          showSuccessToast('注册成功');
          setTimeout(() => {
            router.push({
              path: '/login'
            });
          }, 1500);
        } else {
          showFailToast(res.data.msg);
        }
      });
    };
    const inputChange = () => {
      let time = moment(new Date()).format('YYYY');
      data.nowTime = time - 18;
      if (data.idcard.length == 18) {
        const reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (reg.test(data.idcard)) {
          let y = data.idcard.substring(6, 10);
          if (y > data.nowTime) {
            showToast('年龄未满18，暂时无法注册');
            return;
          }
        } else {
          showFailToast('请输入正确的身份证号');
          return;
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/",
        style: {
          "color": "#7b7b7b"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("返回首页")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_router_link, {
        to: "/login"
      }, {
        default: _withCtx(() => [_createTextVNode("登录")]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/register"
      }, {
        default: _withCtx(() => [_createTextVNode("注册")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          type: "email",
          required: "",
          modelValue: data.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.email = $event),
          placeholder: "邮箱地址"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "text",
          required: "",
          modelValue: data.username,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.username = $event),
          placeholder: "请输入用户名",
          "error-message": "用户名要求不少于4位"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "text",
          required: "",
          modelValue: data.pwd,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.pwd = $event),
          placeholder: "设置登录密码",
          "error-message": "密码要求不少于6位"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "text",
          required: "",
          modelValue: data.pwds,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.pwds = $event),
          placeholder: "重复密码"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "text",
          required: "",
          modelValue: data.realname,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.realname = $event),
          placeholder: "请输入真实姓名"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "text",
          required: "",
          modelValue: data.idcard,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.idcard = $event),
          placeholder: "请输入身份证号",
          onInput: inputChange
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "tel",
          required: "",
          modelValue: data.phone,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.phone = $event),
          placeholder: "请输入手机号",
          maxlength: "11"
        }, {
          button: _withCtx(() => [_createVNode(_component_van_button, {
            size: "small",
            type: "primary",
            disabled: data.codeDisabled,
            onClick: getCode
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.codeName), 1)]),
            _: 1
          }, 8, ["disabled"])]),
          _: 1
        }, 8, ["modelValue"]), _createVNode(_component_van_field, {
          type: "number",
          required: "",
          modelValue: data.smcode,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.smcode = $event),
          placeholder: "短信验证码"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createTextVNode(" 我接受 "), _createVNode(_component_router_link, {
        to: "/agreement"
      }, {
        default: _withCtx(() => [_createTextVNode("《用户注册协议》")]),
        _: 1
      }), _createTextVNode("及 "), _createVNode(_component_router_link, {
        to: "/privacy"
      }, {
        default: _withCtx(() => [_createTextVNode("《隐私政策》")]),
        _: 1
      })]), _createElementVNode("div", {
        class: "button",
        onClick: login
      }, _hoisted_11)])])]);
    };
  }
});